<template>
  <div class="home-container">
    <el-row class="container">
      <el-col :span="24" class="header">
        <el-col :span="1">
          <div class="tools">
            <!-- <i class="fa fa-align-justify"></i> -->
            <img src="../../static/img/ejklogo_01.png" />
          </div>
        </el-col>
        <el-col
          :span="10"
          class="logo"
          :class="collapsed ? 'logo-collapse-width' : 'logo-width'"
          >您好~ {{ collapsed ? "" : user }}</el-col
        >
        <!-- <el-col :span="10">
              <div class="tools" @click.prevent="collapseFun">
                <i class="fa fa-align-justify"></i>
              </div>
            </el-col> -->
        <el-col :span="4" class="userinfo">
          <el-dropdown trigger="hover">
            <img src="../../static/img/tuichuleft.png" alt="" />
            <span class="el-dropdown-link userinfo-inner" @click="logoutFun"
              >退出</span
            >
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>我的消息</el-dropdown-item>
              <el-dropdown-item>设置</el-dropdown-item> -->
              <el-dropdown-item divided @click.native="logoutFun"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-col>
      <el-col :span="24" class="main">
        <aside :class="collapsed ? 'menu-collapsed' : 'menu-expanded'">
          <el-menu
            ref='menu'
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            unique-opened
            v-show="!collapsed"
            style="background: #eeeeef"
            active-text-color="#ffd04b"
            router
          >
            <el-submenu index="1" v-show="isClient">
              <template slot="title">
                <i class=""></i>
                <span>开户数据表</span>
              </template>
              <!-- <el-menu-item index="/menu1">推荐开户数</el-menu-item>
                <el-menu-item index="/menu2">推荐开户明细</el-menu-item>  
                <el-menu-item index="/menu3">推荐关系明细表</el-menu-item>
              <el-menu-item-group>
                <template slot="title">推荐开户表</template>
                <el-menu-item index="/menu1">推荐开户数</el-menu-item>
                <el-menu-item index="/menu2">推荐开户明细</el-menu-item>  
                <el-menu-item index="/menu3">推荐关系明细表</el-menu-item>
              </el-menu-item-group> -->
              <el-menu-item index="/menu1">推荐开户数</el-menu-item>
              <el-menu-item index="/menu2">推荐开户明细</el-menu-item>  
              <el-menu-item index="/menu3">推荐关系明细表</el-menu-item>
              <el-menu-item index="/filiale1">分公司开户进度明细表</el-menu-item>
              <el-menu-item index="/filiale2">分公司开户进度表</el-menu-item>
              <el-menu-item index="/rank1">中支排名表</el-menu-item>
              <el-menu-item index="/rank2">营服排名表</el-menu-item>
              <el-menu-item index="/rank3">个人排名表</el-menu-item>
              <!-- <el-menu-item-group>
                <template slot="title">分公司开户表</template>
                <el-menu-item index="/filiale1">分公司开户进度明细表</el-menu-item>
                <el-menu-item index="/filiale2">分公司开户进度表</el-menu-item>
              </el-menu-item-group> -->
              <!-- <el-menu-item-group>
                <template slot="title">排名表</template>
                <el-menu-item index="/rank1">中支排名表</el-menu-item>
                <el-menu-item index="/rank2">营服排名表</el-menu-item>
                <el-menu-item index="/rank3">个人排名表</el-menu-item>
              </el-menu-item-group> -->
            </el-submenu>
            <!-- <el-submenu index="2">
              <span slot="title">分公司开户表</span>
              <el-menu-item index="/filiale1">分公司开户进度明细表</el-menu-item>
              <el-menu-item index="/filiale2">分公司开户进度表</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="3">
              <span slot="title">排名表</span>
              <el-menu-item index="/rank1">中支排名表</el-menu-item>
              <el-menu-item index="/rank2">营服排名表</el-menu-item>
              <el-menu-item index="/rank3">个人排名表</el-menu-item>
            </el-submenu> -->
            <el-submenu index="4" v-show="isClient">
              <span slot="title">客户数据表</span>
              <el-menu-item index="/client1">客户全量数据表</el-menu-item>
              <el-menu-item index="/client2">关注注册开户分析表</el-menu-item>
              <el-menu-item index="/client3">点击量汇总表</el-menu-item>
            </el-submenu>
            <el-submenu index="5" v-show="isClient">
              <span slot="title">员工数据表</span>
              <el-menu-item index="/indoor1">员工全量数据表</el-menu-item>
              <!-- <el-menu-item index="/indoor2">个险外勤开户明细表</el-menu-item>
              <el-menu-item index="/indoor3">员工个人前50名</el-menu-item>
              <el-menu-item index="/indoor4">营服前50名</el-menu-item> -->
            </el-submenu>
            <el-submenu index="6" v-show="isClient">
              <span slot="title">积分管理</span>
              <el-menu-item index="/organization1">机构负责人金蟾豆列表</el-menu-item>
              <!-- <el-menu-item index="/organization2">金蝌豆明细表(一)</el-menu-item>
              <el-menu-item index="/organization3">金蝌豆明细表(二)</el-menu-item> -->
            </el-submenu>
            <el-submenu index="7" v-show="isClient">
              <span slot="title">每日数据表</span>
              <el-menu-item index="/everydayData1">每日注册数据表</el-menu-item>
              <el-menu-item index="/everydayData2">每日推荐明细数据表</el-menu-item>
            </el-submenu>
            <el-submenu index="8" v-show="isClient">
              <span slot="title">贷款数据表</span>
              <el-menu-item index="/loans1">贷款分析表</el-menu-item>
              <el-menu-item index="/loans2">逾期日报</el-menu-item>
              <!-- <el-menu-item index="/loans3">历史逾期数据表</el-menu-item> -->
              <el-menu-item index="/loans4">贷款放款信息表</el-menu-item>
              <!-- <el-menu-item index="/loans5">贷款还款信息表</el-menu-item> -->
              <el-menu-item index="/loans6">保单贷授信申请表</el-menu-item>
              <el-menu-item index="/loans7">保单贷授信结果表</el-menu-item>
            </el-submenu>
            <el-submenu index="9" v-show="isClient">
              <span slot="title">存款数据表</span>
              <!-- <el-menu-item index="/depositList4">存款统计表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList1">分公司存款分级数据表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList2">中支存款分级数据表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList3">营服存款分级数据表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList5">推荐人明细表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList6">推荐人分析表</el-menu-item> -->
              <!-- <el-menu-item index="/depositList7">存款日报</el-menu-item> -->
              <el-menu-item index="/depositList13">存款分级明细表有效数据</el-menu-item>
              <el-menu-item index="/depositList14">存款分级分公司</el-menu-item>
              <el-menu-item index="/depositList15">存款分级中支</el-menu-item>
              <el-menu-item index="/depositList16">存款分级营服</el-menu-item>
              <!-- <el-menu-item-group>
                <template slot="title">存款分级数据表</template>
                <el-menu-item index="/depositList13">存款分级明细表</el-menu-item>
                <el-menu-item index="/depositList14">存款分级--分公司</el-menu-item>
                <el-menu-item index="/depositList15">存款分级--中支</el-menu-item>
                <el-menu-item index="/depositList16">存款分级--营服</el-menu-item>
              </el-menu-item-group> -->
              <!-- <el-menu-item-group>
                <template slot="title">专属福利</template>
                <el-menu-item index="/depositList7">福利达成进度表</el-menu-item>
                <el-menu-item index="/depositList12">福利总额表</el-menu-item>
              </el-menu-item-group> -->
              <!-- <el-menu-item-group>
                <template slot="title">机构排名周报</template>
                <el-menu-item index="/depositList8">中支排名周报</el-menu-item>
                <el-menu-item index="/depositList9">营服排名周报</el-menu-item>
                <el-menu-item index="/depositList10">业务员排名周报</el-menu-item>
              </el-menu-item-group> -->
              <!-- <el-menu-item index="/depositList11">分公司奖励月报</el-menu-item> -->
            </el-submenu>
            <el-submenu index="10" v-show="isVip">
              <span slot="title">VIP专区</span>
              <el-menu-item index="/venusZone1">申请信息</el-menu-item>
              <!-- <el-menu-item index="/venusZone2">历史客户</el-menu-item> -->
            </el-submenu>
            <el-submenu index="11">
              <span slot="title">各机构数据</span>
              <el-menu-item index="/filialePower1">二级单位数据表</el-menu-item>
              <el-menu-item index="/filialePower2">三级单位数据表</el-menu-item>
            </el-submenu>
            <el-submenu index="12" v-show="isClient">
              <span slot="title">数据上传</span>
              <el-menu-item index="/message1">数据上传</el-menu-item>
              <el-menu-item v-if="userTag=='A'" index="/message2">订单查询</el-menu-item>
              <el-menu-item v-if="userTag=='A'" index="/message3">合同查询</el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="15">
              <span slot="title">编辑器</span>
              <el-menu-item index="/useUe">富文本编辑器</el-menu-item>
            </el-submenu> -->
          </el-menu>
        </aside>
        <section class="content-container">
          <div class="grid-content bg-purple-light">
            <el-col :span="24" class="breadcrumb-container">
              <strong class="title"></strong>
              <el-breadcrumb separator="" class="breadcrumb-inner">
                <el-breadcrumb-item
                  v-for="item in $route.matched"
                  :key="item.path"
                ></el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="24" class="content-wrapper">
              <transition name="fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </el-col>
          </div>
        </section>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      sysName: "",
      sysUserName: "",
      collapsed: false,
      tabPosition: "left",
      show: true,
      token: "",
      user: "",
      isClient:false,//判断客户数据表是否展示
      isVip:false,//VIP审批权限
      userTag:"",//用户标识
    };
  },
  methods: {
    //判断用户权限
    getuserTag(){
      console.log("this.userTag",this.userTag)
      if(this.userTag=="B"){//金科内部权限
        this.isClient=true
      }else if(this.userTag=="A"){//vip专区审批权限
        this.isClient=true;
        this.isVip=false;
      }else{
        this.isClient=false;
        this.isVip=false;
      }
    },
    //折叠导航栏
    collapseFun: function () {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
    //退出登录
    logoutFun() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
  },
  computed: {},
  watch: {
    
  },
  mounted() {
  },
  created() {
    this.token = this.$route.query.token;
    this.userTag = sessionStorage.getItem("userTag");
    this.getuserTag();
    this.user=sessionStorage.getItem("userName");
    console.log("this.user",this.user)
    this.sysName = this.$route.query.user;
    if(!this.user){
      this.$router.push({
        path:"/login"
      })
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
}
.container .header {
  height: 3.7rem;
  line-height: 3.7rem;
  border-bottom: 1px solid #ecf0f1;
}
.container .header .userinfo {
  text-align: right;
  padding-right: 2.1rem;
  float: right;
}
.container .header .userinfo-inner {
  cursor: pointer;
  font-size: 1rem;
}
.container .header .userinfo img {
  width: 1rem;
  height: 1rem;
}

.container .header .logo {
  margin-left: 11rem;
  height: 3.7rem;
  font-size: 1rem;
  border-color: rgba(238, 241, 146, 0.3);
  border-right-width: 1px;
  border-right-style: solid;
  letter-spacing: 0.1rem;
}
.container .header .logo-width {
  width: 13.8rem;
}
.container .header .logo-collapse-width {
  width: 3.6rem;
}
.tools {
  width: 13.8rem;
  text-align: center;
  height: 3.6rem;
  line-height: 3.6rem;
  cursor: pointer;
  background: #eeeeef;
}
.tools img {
  width: 60%;
  height: 60%;
  margin-top: 0.6rem;
}

.main {
  display: flex;
  position: absolute;
  top: 3.6rem;
  bottom: 0;
  /* overflow: hidden; */
}
.homeLogo {
  height: 3.6rem;
  line-height: 3.6rem;
  background: #eef1f6;
}
.homeLogo img {
  width: 60%;
  height: 60%;
  margin-top: 0.6rem;
}

aside {
  flex: 0 0 13.8rem;
  width: 13.8rem;
}
aside .el-menu {
  /* height: 100%; */
}
aside .collapsed {
  width: 3.6rem;
}
aside .collapsed .item {
  position: relative;
}
aside .collapsed .submenu {
  position: absolute;
  top: 0;
  left: 3.6rem;
  height: auto;
  display: none;
}

.KHS {
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  border-bottom: 1px solid #475669;
}

.menu-collapsed {
  flex: 0 0 3.6rem;
  width: 3.6rem;
}
.menu-expanded {
  flex: 0 0 13.8rem;
  width: 13.8rem;
  background: rgb(238, 238, 239);
  overflow: auto;
}
.content-container {
  flex: 1;
  overflow-y: scroll;
  padding: 1.2rem;
}

.breadcrumb-container .title {
  width: 12rem;
  float: left;
  color: #475669;
}
.breadcrumb-container .breadcrumb-inner {
  float: right;
}

.content-wrapper {
  background-color: #fff;
  box-sizing: border-box;
}
.el-submenu__title:hover {
  background-color: #ff9d47;
}
/*修改左侧导航栏样式*/
.navMenu >>> .el-menu-item:hover {
  /*二级路由*/
  /* background-color: #ff9d47;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  color: #fff; */
}
/*设置选中el-menu-item时的样式*/
.el-menu-item.is-active {
  background-color: #ff9d47 !important;
  color: #ffffff !important;
}

.navMenu >>> .el-submenu__title:hover {
  /*一级路由*/
  /* background-color: #ff9d47;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  color: #fff; */
}
</style>



// WEBPACK FOOTER //
// home.vue?727c07f8